import { api } from "./base.api.ts"

export const getAllClassesByGeo = async ({ lat, long }) => {
  const res = await api.get("dashboard/getTeacherUnderClass", {
    params: { lat, long },
  })
  return res.data.data
}

export const getUserDetailsById = async (user_id) => {
  const res = await api.get(`dashboard/getUserDetails/${user_id}`)
  return res.data.data
}
